export const onPhoneNumberChange = (e) => {
  let value = e.target.value;
  e.target.value = normalizePhoneNumber(value)
  return e;
}

const normalizePhoneNumber = (value, previousValue) => {
  // return nothing if no value
  if (!value) return value; 

  // only allows 0-9 inputs
  const currentValue = value.replace(/[^\d]/g, '');
  const cvLength = currentValue.length; 

  if (!previousValue || value.length > previousValue.length) {

    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue; 

    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`; 

    // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`; 
  }
};

export const languageCodeConverter = (langCode) => {
  let languageNames = new Intl.DisplayNames([langCode], { type: 'language' });
  const languageName = languageNames.of(langCode);
  return languageName.charAt(0).toUpperCase() + languageName.slice(1);
};

export const formatDuration = (minutes) => {
  if (minutes < 60) {
    return { hours: 0, minutes: minutes };
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return { hours, minutes: remainingMinutes };
};
